import { render, staticRenderFns } from "./AltSidebar.vue?vue&type=template&id=07ad8ab7&scoped=true"
import script from "./AltSidebar.vue?vue&type=script&lang=js"
export * from "./AltSidebar.vue?vue&type=script&lang=js"
import style0 from "./AltSidebar.vue?vue&type=style&index=0&id=07ad8ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ad8ab7",
  null
  
)

export default component.exports